<div *ngIf="loading" class="flex items-center justify-center">
	<app-icon
		[icon]="ICON.LOADING"
		class="text-4xl mr-3 text-grey"
		[spin]="true"
	></app-icon>
</div>

<div *ngIf="!loading">
	<div *ngIf="!showManualProviders">
		<h4>Select title insurance provider</h4>
		<p class="mt-5">
			Choose from any of the following industry-leading title insurance
			providers to insure your transaction.
		</p>
		<div class="mt-10 flex flex-col gap-8">
			<div class="flex items-center justify-center gap-4">
				<div
					class="provider"
					[class.selected]="_selectedType === types.FCT"
					(click)="_selectedType = types.FCT"
				>
					<img class="logo" src="/assets/images/integrations/fct-logo.svg" />
					<div class="text-sm pill">
						<app-icon [icon]="ICON.INTEGRATED" class="mr-2"></app-icon>
						<span>Integrated</span>
					</div>
				</div>

				<div
					class="provider"
					[class.selected]="_selectedType === types.CHICAGO"
					(click)="_selectedType = types.CHICAGO"
				>
					<img
						class="logo"
						src="/assets/images/integrations/chicago-title-logo.svg"
					/>
					<div class="text-sm pill">
						<app-icon [icon]="ICON.INTEGRATED" class="mr-2"></app-icon>
						<span>Integrated</span>
					</div>
				</div>

				<div
					class="provider"
					[class.selected]="_selectedType === types.STEWART"
					(click)="_selectedType = types.STEWART"
				>
					<img
						class="logo"
						src="/assets/images/integrations/stewart-title-logo-square.svg"
					/>
					<div class="text-sm pill">
						<app-icon [icon]="ICON.INTEGRATED" class="mr-2"></app-icon>
						<span>Integrated</span>
					</div>
				</div>

				<div
					class="provider"
					[class.selected]="_selectedType === types.TITLE_PLUS"
					(click)="_selectedType = types.TITLE_PLUS"
				>
					<img
						class="logo"
						src="/assets/images/integrations/title-plus-logo.svg"
					/>
					<div class="text-sm pill">
						<app-icon [icon]="ICON.INTEGRATED" class="mr-2"></app-icon>
						<span>Integrated</span>
					</div>
				</div>
			</div>

			<div class="w-3/4 mx-auto flex gap-2 items-center justify-between mt-1">
				<hr class="w-1/2 mt-2" />
				<p>OR</p>
				<hr class="w-1/2 mt-2" />
			</div>

			<div
				class="provider manual self-center"
				[class.selected]="_selectedType === types.MANUAL"
				(click)="_selectedType = types.MANUAL"
			>
				<div class="text-center flex items-center gap-3">
					<app-icon [icon]="ICON.EDIT"></app-icon>
					<p class="text-lg text-grey-darker">Manual entry</p>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="showManualProviders">
		<h4>Select title insurance provider</h4>
		<p class="mt-5">
			Choose from any of the following industry-leading title insurance
			providers to insure your transaction.
		</p>
		<div class="mt-10 flex flex-col gap-8">
			<div class="flex gap-4">
				<div
					class="provider w-1/2"
					[class.selected]="_selectedType === types.FCT"
					(click)="_selectedType = types.FCT"
				>
					<img class="logo" src="/assets/images/integrations/fct-logo.svg" />
					<div
						*ngIf="propertyUsage === PropertyUsage.COMMERCIAL"
						class="text-sm pill autofill-form"
					>
						<span>Autofill form</span>
					</div>
				</div>
				<div
					class="provider w-1/2"
					[class.selected]="_selectedType === types.CHICAGO"
					(click)="_selectedType = types.CHICAGO"
				>
					<img
						class="logo"
						src="/assets/images/integrations/chicago-title-logo.svg"
					/>
					<div
						*ngIf="propertyUsage === PropertyUsage.COMMERCIAL"
						class="text-sm pill manual"
					>
						<span>Manual</span>
					</div>
				</div>
				<div
					class="provider w-1/2"
					[class.selected]="_selectedType === types.STEWART"
					(click)="_selectedType = types.STEWART"
				>
					<img
						class="logo"
						src="/assets/images/integrations/stewart-title-logo.svg"
					/>
					<div
						*ngIf="propertyUsage === PropertyUsage.COMMERCIAL"
						class="text-sm pill manual"
					>
						<span>Manual</span>
					</div>
				</div>
				<div
					class="provider w-1/2"
					[class.selected]="_selectedType === types.TITLE_PLUS"
					(click)="_selectedType = types.TITLE_PLUS"
				>
					<img
						class="logo"
						src="/assets/images/integrations/title-plus-logo.svg"
					/>
					<div
						*ngIf="propertyUsage === PropertyUsage.COMMERCIAL"
						class="text-sm pill manual"
					>
						<span>Manual</span>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="flex justify-between my-8">
		<app-button btn="secondary" size="small" (click)="close()"
			>Cancel</app-button
		>
		<app-button size="small" (click)="save()" [disabled]="!_selectedType"
			>Continue</app-button
		>
	</div>

	<atomic-message-bar
		type="warn"
		*ngIf="submitted && !_selectedType"
		[@openClose]
		>Select an insurance provider to continue</atomic-message-bar
	>
</div>
